import type { Game, Trade } from '../../types/game'
import { ResourceIcon } from '../shared/ResourceIcon'
import { assetUrl } from '../../utils/assets'

interface QueenTradingModalProps {
  game: Game
  onTrade: (tradeId: string) => void
  onFinish: () => void
}

function TradeItem({ trade, onTrade }: { trade: Trade; onTrade: () => void }) {
  return (
    <div className="queen-trading-player-offer-resource" onClick={onTrade}>
      <div>{trade.tit_n}</div>
      <ResourceIcon resource={trade.tit_r} />
      <div>:</div>
      <div>{trade.tat_n}</div>
      <ResourceIcon resource={trade.tat_r} />
    </div>
  )
}

function MobileTradeItem({ trade, onTrade }: { trade: Trade; onTrade: () => void }) {
  return (
    <div className="queen-trading-mobile-trade" onClick={onTrade}>
      <div className="queen-trading-mobile-trade-give">
        <div>{trade.tit_n}</div>
        <ResourceIcon resource={trade.tit_r} />
      </div>
      <div className="queen-trading-mobile-trade-sep">for</div>
      <div className="queen-trading-mobile-trade-get">
        <div>{trade.tat_n}</div>
        <ResourceIcon resource={trade.tat_r} />
      </div>
    </div>
  )
}

export function QueenTradingModal({ game, onTrade, onFinish }: QueenTradingModalProps) {
  return (
    <div className="queen-trading-modal-root">
      <div className="queen-trading-overlay" onClick={onFinish} />
      <div className="queen-trading-container">
        <div className="queen-trading tableau">
          <div className="queen-trading-content desktop-shell-view">
            <div className="queen-trading-column">
              <div className="queen-trading-header">
                <div className="queen-trading-title">Queen</div>
                <div className="queen-trading-description">Trade resources with the Queen</div>
              </div>
              <img src={assetUrl('images', 'queen.png')} alt="" />
            </div>
            <div className="queen-trading-column">
              <div className="queen-trading-body-container">
                <div className="queen-trading-player-offer">
                  {game.queen.trades.map((trade) => (
                    <TradeItem key={trade.id} trade={trade} onTrade={() => onTrade(trade.id)} />
                  ))}
                </div>
                <div className="queen-trading-close-container">
                  <div id="queen-trading-close" className="queen-trading-close" onClick={onFinish}>
                    Close
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="queen-trading-mobile-shell mobile-shell-view">
            <div className="mobile-modal-shell queen-trading-mobile-card">
              <div className="mobile-modal-header">
                <div className="mobile-modal-title">Queen</div>
                <div id="queen-trading-mobile-close" className="mobile-modal-close-button lobby-start" onClick={onFinish}>Close</div>
              </div>
              <div className="mobile-modal-hero queen-trading-mobile-hero">
                <img src={assetUrl('images', 'queen.png')} alt="" />
              </div>
              <div className="mobile-modal-section">
                <div className="mobile-modal-section-title">Available Trades</div>
                <div className="queen-trading-mobile-offer">
                  {game.queen.trades.map((trade) => (
                    <MobileTradeItem key={`mobile-${trade.id}`} trade={trade} onTrade={() => onTrade(trade.id)} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
